
import { Enums } from '@bode-canada/core';
import {
  Head,
  Info,
  NotesPictures,
  NewOffer,
  MarketDays,
  SoldData,
  NewListing,
} from './components';
import { IconType } from '@/ui-kit/components/icon/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { ShapeType } from '@/ui-kit/components/icon-button/enums';
import Action from './action';
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';
import WindowSize from '@/ui-kit/mixins/windowSize';
import Listing from '@/models/listing';

const { ListingStatusEnum, ListingOriginEnum } = Enums;

export default {
  name: 'ListingCardComponent',
  components: {
    Action,
    Head,
    Info,
    NotesPictures,
    NewOffer,
    MarketDays,
    NewListing,
    SoldData,
  },
  mixins: [WindowSize],
  props: {
    listing: {
      type: Object,
      default: () => {},
    },
    user: {
      type: Object,
      default: null,
    },
    actions: {
      type: Array,
      default() {
        return [];
      },
    },
    mainAction: {
      type: Object,
      required: false,
      default() {
        return null;
      },
    },
    imageAction: {
      type: Object,
      default: null,
    },
    isHorizontal: {
      default: false,
      type: Boolean,
    },
    isFavourite: {
      type: Boolean,
      default: false,
    },
    isSoldListing: {
      default: false,
      type: Boolean,
    },
    isShowBodeExclusive: {
      default: false,
      type: Boolean,
    },
    isShowStatusInfo: {
      default: false,
      type: Boolean,
    },
    isSoldPinShown: {
      default: true,
      type: Boolean,
    },
    isHideActionButton: {
      default: false,
      type: Boolean,
    },
    isHideChip: {
      default: false,
      type: Boolean,
    },
    isMyListings: {
      default: false,
      type: Boolean,
    },
    isProfile: {
      default: false,
      type: Boolean,
    },
    isDaysOnMarketVisible: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    StyleColorSchemeType,
    ShapeType,
    IconType,
  }),
  computed: {
    listingModel() {
      return new Listing({ listing: this.listing });
    },
    showNewOffers() {
      const {
        lastViewedFromMyListings,
        newOfferCount,
        latestOfferDate,
      } = this.listing;

      return newOfferCount > 0 && (!lastViewedFromMyListings
          || latestOfferDate > lastViewedFromMyListings);
    },
    isBode() {
      return this.listing.origin === ListingOriginEnum.BODE;
    },
    isSold() {
      return this.listing.status === ListingStatusEnum.SOLD || this.isSoldListing;
    },
    isBuilder() {
      return this.$store.getters['user/isBuilderListingSub'];
    },
    isBuilderPendingInfoVisible() {
      const isMyListingsBuilder = this.isMyListings && this.isBuilder;
      const isActiveListing = this.listing.status === Enums.ListingStatusEnum.ACTIVE;
      const doesListingHaveClosingDate = !!this.listing?.closedAt;

      return isMyListingsBuilder && isActiveListing && doesListingHaveClosingDate;
    },
    cardClassNames() {
      const {
        isBode,
        isSold,
        listing,
        isHorizontal,
      } = this;
      return new StyleClassNamesBuilder('listing-card')
        .addConditionClassName('sold', isSold && isBode)
        .addConditionClassName('pinky-border', listing.listingId && !isBode)
        .addConditionClassName('horizontal', isHorizontal
          && this.isGreaterThan(this.breakpoints.Small))
        .build();
    },
  },
};
